import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const Content = styled.div``;
